const HTML_ESCAPE_MAP: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
}

export function escapeHtml(str: string): string {
  return str.replace(/[&<>"]/g, (c) => HTML_ESCAPE_MAP[c])
}
